import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlePreview() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
          品牌资讯
        </h2>
        <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
          掌握欧美精品最新动态，了解更多品质生活灵感
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {latestArticles.map((article) => (
          <Link
            key={article.id}
            to={`/articles/${article.slug}`}
            className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 transition-colors hover:border-background-300/60"
          >
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center gap-3 text-[11px] text-foreground-400 mb-2">
                <span>{article.date}</span>
                <span>·</span>
                <span>{article.readTime}</span>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{article.excerpt}</p>
              <div className="mt-3 flex flex-wrap gap-1">
                {article.tags.map((tag) => (
                  <span key={tag} className="text-[10px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </Link>
        ))}
      </div>
      <div className="text-center mt-8">
        <Link
          to="/articles"
          className="inline-block px-6 py-2.5 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:bg-foreground-50 transition-colors whitespace-nowrap"
        >
          查看全部文章
        </Link>
      </div>
    </section>
  );
}